export default "__VITE_ASSET__a4a586eb__$_?nuxt_component=async&nuxt_component_name=SvgoFreedoge__"